export function filters() {
    let appliedFilters = $(".filters-list");
    $(document).on('click', '.clear-filter', function(event) {
        $(this).parents('.item').remove();
        jcf.replaceAll();
        $('.blog-posts-filter').trigger("reset");
    });
    let selectElements = $('.blog-posts-filter select');
    function filtered(selector) {
        let selectedValue = $(selector).val();
        if (selectedValue == '') {
            $(appliedFilters).html(" ");
            appliedFilters.hide();
        } else {
            appliedFilters.show();
            $(appliedFilters).html(" ");
            setTimeout(() => {
                let selectedOption = `
                <li class="item">
                <span class="filter-title">${selectedValue}</span>
                <button class="clear-filter" type="button"></button>
                </li>
                `;
                $(selectedOption).appendTo(appliedFilters);
            }, 100)
        }
    }
    filtered(selectElements);
    $(selectElements).on('change', function(event) {
        filtered(selectElements);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/filters.js